import {
  Box, DashboardModule, Image, Text,
} from '@domain-group/suit-theme'

import placeholderImageUrl from './assets/placeholder.svg'

interface DetailsProps {
  entityName: string,
  image?: string,
  loading?: boolean,
  title: string,
}

const Details = (props: DetailsProps) => {
  const {
    entityName, image, loading, title,
  } = props

  return (
    <DashboardModule contentBoxProps={{ padding: 'large' }} loading={loading} title={entityName}>
      <Box
        border="1px solid"
        borderColor="lineColor"
        borderRadius={5}
        height={40}
        marginRight="large"
        padding="large"
        variant="center"
        width={60}
      >
        <Image
          backgroundSize="cover"
          // @ts-expect-error TS2322
          border="1px solid"
          borderColor="lineColor"
          borderRadius={5}
          placeholderUrl={placeholderImageUrl}
          url={image}
          height={40}
          width={60}
        />
      </Box>

      <Box flexDirection="column" justifyContent="center">
        <Text fontSize="small">
          {title}
        </Text>
      </Box>
    </DashboardModule>
  )
}

export default Details
